var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Kanit",staticStyle:{"padding":"15px","height":"100vh","overflow":"scroll","background":"#2562af"}},[_c('v-img',{staticStyle:{"max-width":"250px","margin":"auto"},attrs:{"src":"/static/img/icons/logoonechat_full-white.png"}}),_vm._v(" "),_c('div',{staticClass:"bginform"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f784c4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/consent/consent.vue
// module id = null
// module chunks = 